import React from 'react';
import ClientsByApps from '../../modules/ClientApps/components/ClientsByApps';

const ClientsByAppsPage = () => {
  return (
    <ClientsByApps />
  );
};

export default ClientsByAppsPage;